<template>
  <div
    v-if="domainSplitEnabled"
    id="alert-banner"
    class="banner-warning"
  >
    <span v-if="preSplitEnabled">{{ $t(`${i18nPrefix}.preUrlSwitch`) }}</span>
    <span v-else>{{ $t(`${i18nPrefix}.postUrlSwitch`) }}</span>
  </div>
</template>

<script>

import { RG_7527_DOMAIN_SWITCH, RG_7527_PRE_DOMAIN_SWITCH } from '@/components/shared/split/split-constants'

export default {
  name: 'LoginAlert',
  computed: {
    domainSplitEnabled () {
      return this.$isSplitEnabled(RG_7527_DOMAIN_SWITCH)
    },
    preSplitEnabled () {
      return this.$isSplitEnabled(RG_7527_PRE_DOMAIN_SWITCH)
    },
    i18nPrefix () {
      return 'portalfrontendApp.topBar'
    }
  }
}
</script>

<style scoped lang="scss">
  #alert-banner{
    &.banner-warning {
      background-color: var(--t-color-status-warning);
    }
    position: fixed;
    top:0;
    left:0;
    width:100%;
    display: flex;
    min-height: 40px;
    margin: 0;
    padding:1rem;
    font-size: 16px;
    font-weight: bold;
    align-content: center;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
</style>
